import { z } from 'zod';
import { BackendBaseEnvSchema } from './backendBase';

// Separate guardian specific environment variables from server sync/async
// Guardian Lambda doesn't use Redis (no BullMQ) so make Redis optional
const GuardianEnvSchema = BackendBaseEnvSchema.extend({
  // AWS Configuration
  AWS_REGION: z.string().default('us-east-2'),

  // KMS Configuration
  // Note: KMS_KEY_ID is no longer required at runtime - guardian fetches active key from database
  // It's still useful for direct testing scripts
  KMS_KEY_ID: z
    .string()
    .optional()
    .describe('AWS KMS Key ID for direct testing (not needed at runtime)'),

  // Local Development Configuration
  // When ENVIRONMENT=LOCAL, Guardian uses this private key instead of AWS KMS
  // This should be the private key derived from the MLS Wallet Dev Seed Phrase (index 4)
  LOCAL_GUARDIAN_PRIVATE_KEY: z
    .string()
    .optional()
    .describe(
      'Private key for Guardian signing in LOCAL mode (test-guardian-executor from seed phrase index 4)'
    ),

  // Lambda-specific database connection variables
  // These are ONLY set in Lambda, not in local development
  // Local development uses DATABASE_URL directly from .env
  DB_HOST: z.string().optional(),
  DB_PORT: z.string().optional(),
  DB_NAME: z.string().optional(),
  DB_SECRET_ARN: z.string().optional(),
  ENV_VARS_SECRET_ARN: z.string().optional(),
});

type GuardianEnv = z.infer<typeof GuardianEnvSchema>;

export function getGuardianEnvVariables(): GuardianEnv {
  return GuardianEnvSchema.parse(process.env);
}
